import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export function postCertificatesAccept(certificateSlug: string, generateImmediately: boolean, data: any) {
    const { apiPostCertificatesAccept } = apiConfig.getStaticUrls();

    return postFetch(apiPostCertificatesAccept, {
        certificate_slug: certificateSlug,
        generate_immediately: generateImmediately,
        ...data,
    });
}
